export const ONETRUST_TRACKING_GROUP = "C0004";

export const EVENTS = {
  actionFailed: "action_failed",
  buttonClicked: "button_clicked",
  pageViewed: "page_viewed",
};

export const ITEMS = {
  confirmBenefitsOwner: "confirm_benefits_owner",
  gotoMemberships: "go_to_memberships",
  gotoVenues: "go_to_venues",
  submitEmailAddress: "submit_email_address",
  verifyEmailAddress: "verify_email_address",
};
